import { render } from "./JoinLine.vue?vue&type=template&id=652d83ee&scoped=true"
const script = {}

import "./JoinLine.vue?vue&type=style&index=0&id=652d83ee&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-652d83ee"]])

export default __exports__